import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContractData } from '../intefaces/contract-data.interface';
import { RequestResponse } from '../intefaces/requestResponse';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class ContractService extends BaseService {

    constructor(protected http: HttpClient) {
        super();
    }

    public updateContractData(contractData: ContractData) {
        return this.http.post<RequestResponse>(this.getUrl('updateContractData'), { contract_data: contractData }).pipe();
    }

    public getContractData() {
        return this.http.get<RequestResponse>(this.getUrl('getContractData')).pipe();
    }

    public downloadTestContract(): Observable<Blob> {
        return this.http.get(this.getUrl('generateTestContract'), { responseType: 'blob' });
    }

    public getContractEmail() {
        return this.http.get<RequestResponse>(this.getUrl('getContractEmail')).pipe();
    }

    public sendTestContractEmail(email: string) {
        return this.http.post<RequestResponse>(this.getUrl('sendTestContractEmail'), { email: email }).pipe();
    }

    public getContractSearch(params: any, page: number, rows: number, user_id: number) {
        let data = { params: params, page: page, rows: rows, user_id: user_id };
        return this.http.post<RequestResponse>(this.getUrl('getContractSearch'), data).pipe();
    }

    public editContract(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('editContract'), { id: id }).pipe();
    }

    public submitEditedContract(data: any) {
        return this.http.post<RequestResponse>(this.getUrl('submitEditedContract'), { data: data }).pipe();
    }

    public setContractToDefault(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('setContractToDefault'), { id: id }).pipe();
    }

    public acceptContract(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('acceptContract'), { id: id }).pipe();
    }

    public getContract(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('getContract'), { id: id }).pipe();
    }

    public signContract(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('signContract'), { id: id }).pipe();
    }

    public getContractAttachments(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('getContractAttachments'), { id: id }).pipe();
    }

    public saveContractAttachment(formData: FormData) {
        return this.http.post<RequestResponse>(this.getUrl('saveContractAttachment'), formData).pipe();
    }

    public acceptContractAttachment(contractId: number, contractAttachmentId: number) {
        return this.http.post<RequestResponse>(this.getUrl('acceptContractAttachment'), { contract_id: contractId, contract_attachment_id: contractAttachmentId }).pipe();
    }

    public rejectContractAttachment(contractId: number, contractAttachmentId: number) {
        return this.http.post<RequestResponse>(this.getUrl('rejectContractAttachment'), { contract_id: contractId, contract_attachment_id: contractAttachmentId }).pipe();
    }

    public deleteContractAttachment(contractId: number, contractAttachmentId: number) {
        return this.http.post<RequestResponse>(this.getUrl('deleteContractAttachment'), { contract_id: contractId, contract_attachment_id: contractAttachmentId }).pipe();
    }

    public downloadContractAttachment(contract_id: any, contract_attachment_id: any): Observable<any> {
        return this.http.get(this.getUrl('downloadContractAttachment'), { params: { contract_id: contract_id, contract_attachment_id: contract_attachment_id }, responseType: 'blob' });
    }

    public downloadContract(contract_id: any): Observable<any> {
        return this.http.get(this.getUrl('downloadContract'), { params: { contract_id: contract_id }, responseType: 'blob' });
    }

}
